import { DateInputV2 } from "@inputs/date/DateInputV2";
import { Alert, Typography } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { useI18nContext } from "@root/utils/organisation";
import { StackGrid } from "@styleguide";
import { set } from "date-fns";
import { InputSetting } from "../../inputs/setting";
import { Interview } from "../components/apply/interview";
import { useModalOfferContext } from "../context";
import { initApply } from "../logics";

export const StatusSection = () => {
  const { settings } = useGlobalContext();
  const { apply, setApply, errors, setErrors, disabledFields } = useModalOfferContext();
  const { timeZone } = useI18nContext();

  return (
    <>
      <Typography variant="subtitle2SemiBold" color="primary">
        Statut de la candidature
      </Typography>

      {!apply.status && (
        <Alert severity="info">
          Veuillez renseigner le statut de la candidature afin de voir apparaître les champs complémentaires qui vous
          seront demandés ensuite.
        </Alert>
      )}
      <StackGrid perLine={2} gap={2}>
        <InputSetting
          id="status"
          label="Statut de la candidature*"
          setting={settings.ampJobStatusForApply}
          value={apply.status}
          onChange={(event) => setApply({ ...initApply, status: event.target.value })}
          error={!!errors.status}
          variant="outlined"
          disabled={disabledFields?.applyStatus}
        />
        {apply.status === "waiting_itw" && <Interview label="Date de l'entretien *" showTypography={false} />}

        {apply.status === "success" && (
          <DateInputV2
            label="Date de début de contrat*"
            value={apply.contractStartDate ? new Date(apply.contractStartDate) : null}
            onChange={(date) => {
              if (!date || Number.isNaN(date.getTime())) {
                return;
              }
              setApply((apply) => ({
                ...apply,
                contractStartDate: set(date, { hours: 10, minutes: 0, seconds: 0, milliseconds: 0 }).toISOString(),
              }));
              setErrors((errors) => ({ ...errors, contractStartDate: false }));
            }}
            TextFieldProps={{
              id: "hiring-date",
              size: "small",
              error: !!errors.contractStartDate,
              placeholder: "Saisissez une date",
            }}
            timeZone={timeZone}
          />
        )}
      </StackGrid>
    </>
  );
};
